import  React, 
        {
            useEffect, 
        }                                   from "react";
import  {   RefreshBtn,}                    from "components/Button/button";        
import  {   DropdownListMultiple,}          from "components/DropdownListField/dropdownListFIeld";
import  Style                               from "components/UI/main.module.scss";
import { GetSystemLabel } from "Utilities/utils";

export const StatusFilter              = React.memo(({...props}) => {
    const   { 
        Main,
        Manager,
        Action,        
    }                                   = props;

    useEffect(() => {
        if (!Main) return;
    }, [Main, Manager, Action]);

    return(
        <React.Fragment>
            <div    style={{
                        width: '20rem'
                    }}                    
                    className={[    Style.d_flex, 
                                    Style.align_items_center, 
                                    Style.justify_content_center
                    ].join(" ")}
            >
                <RefreshBtn
                    Label={{text: GetSystemLabel("Update"), style: [Style.text_body, Style.fs_8, Style.mx_1].join(" ")}}
                    Button={{
                        class:      [   Style.d_flex,
                                        Style.align_items_center,
                                        Style.justify_content_center,
                                        Style.clickable,  
                                        Style.rounded_3, 
                                        Style.border, 
                                        Style.shadow_sm, 
                                        Style.vanilla_bg, 
                                        Style.text_center, 
                                        Style.pop_item_animation,
                                    ].join(" "),
                        style:      {}
                    }}
                    Action={Action}                         
                />
                <DropdownListMultiple
                    value={Manager.state[`${Manager?.keyAttribute}`]}
                    placeholder={""}
                    listOfItems={
                        Main
                        ? 
                            Main?.list?.map((d) => ({ value: d[`${Main?.keyAttribute}`], label: d[`${Main?.keyAttributeName}`]}))
                        : 
                            null
                    }
                    style={{ width: "100%" }}
                    onChange={(valueArray) => {
                        Manager?.setState(prevState => ({
                            ...prevState,
                            [`${Manager?.keyAttribute}`]: valueArray
                        }));
                    }}
                />        
            </div>
        </React.Fragment>
    );    
});